module.exports = __webpack_public_path__ + "img/home_swiper_02.d5c1f0d0.jpg";